import { SafeAreaView, StyleSheet, ScrollView, RefreshControl, View, findNodeHandle, Dimensions, Platform } from 'react-native';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { showMessage } from "react-native-flash-message";
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomButton from '../../../components/CustomButton';
import CustomNumericInput from '../../../components/CustomNumericInput';
import CustomText from '../../../components/CustomText/CustomText';
import CustomPhoneNumber from '../../../components/CustomPhoneNumber';
import CountriesWithFlagsList from '../../../constants/CountriesWithFlagsList.js';
import CustomDropDownWithIcons from '../../../components/CustomDropDownWithIcons';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useAccount } from '../../../hooks/useAccount';
import { useTheme } from '@react-navigation/native';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import KeyboardAwareContainer from '../../../components/Platform/KeyboardAwareContainer';

// * Language 
import { useTranslation } from 'react-i18next';

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var width = Dimensions.get('window').width; //full width

const MyAccountPersonalInformationScreen = ({ navigation }) => {

    //#region UseState and consts.
    const { t, i18n } = useTranslation();

    // TODO: This is not defined in the Database, hardcoding for now for Marital Status 
    const mStatus = [
        { label: t('common:single'), value: 'Single' },
        { label: t('common:married'), value: 'Married' },
        { label: t('common:engaged'), value: 'Engaged' },
        { label: t('common:divorced'), value: 'Divorced' },
        { label: t('common:widow'), value: 'Widow(er)' },
    ];

    var validator = require("email-validator");
    const insets = useSafeAreaInsets();

    const { colors } = useTheme();
    const styles = makeStyles(colors);

    const { account } = useAccountContext();
    const { accountGet, accountEdit, isLoading, error } = useAccount();
    const { username, user, clientApi } = useAuthContext();

    const maritalStatusRef = useRef(null);
    const numOfChildrenRef = useRef(null);
    const addressRef = useRef(null);
    const townRef = useRef(null);
    const countryRef = useRef(null);
    const postCodeRef = useRef(null);
    const mobileInputRef = useRef(null);
    const personalMobileStoredRef = useRef(null);
    const personalEmailRef = useRef(null);
    const submitClickedRef = useRef(null);

    const [submitClicked, setSubmitClicked] = useState(false);
    const [countriesWithFlagsList, setCountriesWithFlagsList] = useState([]);
    const [maritalStatus, setMaritalStatus] = useState(null);
    const [numOfChildren, setNumOfChildren] = useState(0);

    const [address, setAddress] = useState("");
    const [town, setTown] = useState("");
    const [country, setCountry] = useState("");
    const [postcode, setPostcode] = useState("");
    const [personalMobileStored, setPersonalMobileStored] = useState("");
    const [personalMobileDefaultCode, setPersonalMobileDefaultCode] = useState(undefined);
    const [personalMobileFormatted, setPersonalMobileFormatted] = useState("");
    const [personalEmail, setPersonalEmail] = useState("");

    // validation error values
    const [maritalError, setMaritalError] = useState("");
    const [childrenError, setChildrenError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [townError, setTownError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [postcodeError, setPostcodeError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [refreshing, setRefreshing] = useState(false);

    //#endregion

    // TODO: make loading work
    // const [loading, setLoading] = useState(true);

    // * Validation for Required (not needed currently)
    // const validateMarital = () => {
    //     if (maritalStatusRef.current === null) {
    //         setMaritalError(t('common:errRequired'));
    //         return false;
    //     } else {
    //         setMaritalError("");
    //         return true;
    //     };
    // };

    // * Validation for Required (not needed currently)
    // TODO: children
    // const validateChildren = () => {
    //     if (numOfChildrenRef.current === null) {
    //         setChildrenError(t('common:errRequired'));
    //         return false;
    //     } else {
    //         setChildrenError("");
    //         return true;
    //     };
    // };

    // * Validation for Required (not needed currently)
    // const validateAddress = () => {
    //     if (addressRef.current === "") {
    //         setAddressError(t('common:errRequired'));
    //         return false;
    //     } else {
    //         setAddressError("");
    //         return true;
    //     };
    // };

    const validateTown = () => {
        // * Validation for Required (not needed currently)
        // if (townRef.current === "") {
        //     setTownError(t('common:errRequired'));
        //     return false;
        if (/[0-9]/.test(townRef.current)) {
            setTownError(t('common:errTown'));
            return false;
        } else {
            setTownError("");
            return true;
        };
    };

    // * Validation for Required (not needed currently)
    // const validateCountry = () => {
    //     if (countryRef.current === "") {
    //         setCountryError(t('common:errRequired'));
    //         return false;
    //     } else {
    //         setCountryError("");
    //         return true;
    //     };
    // };

    // * Validation for Required (not needed currently)
    // const validatePostcode = () => {
    //     if (postCodeRef.current === "") {
    //         setPostcodeError(t('common:errRequired'));
    //         return false;
    //     } else {
    //         setPostcodeError("");
    //         return true;
    //     };
    // };

    const validateMobile = () => {
        // * Validation for Required (not needed currently)
        // if (!personalMobileStoredRef.current) {
        //     setMobileError(t('common:errRequired'));
        //     return false;
        if (mobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().number != "") {
            if (mobileInputRef.current?.isValidNumber(mobileInputRef.current?.getNumberAfterPossiblyEliminatingZero().formattedNumber)) {
                setMobileError("");
                return true;
            } else {
                setMobileError(t('common:errMobile'));
                return false;
            };
        } else {
            setMobileError("");
            return true;
        };
    };

    // TODO: check new email does not exist in DB & validate
    /*  function isValidEmail(email) {
            return /\S+@\S+\.\S+/.test(email);
        }
    */

    const validateEmail = () => {
        // * Validation for Required (not needed currently)
        // if (personalEmailRef.current === "") {
        //     setEmailError(t('common:errRequired'));
        //     return false;
        if (personalEmailRef.current === "" || validator.validate(personalEmailRef.current)) {
            setEmailError("");
            return true;
        } else {
            setEmailError(t('common:errEmail'));
            return false;
        };
    };

    const validateFields = () => {
        // * Validation for Required (not needed currently)
        // if (!validateMarital() | !validateChildren() | !validateAddress() | !validateTown() | !validateCountry() | !validatePostcode() | !validateMobile() | !validateEmail()) {
        if (!validateTown() | !validateMobile() | !validateEmail()) {
            return false;
        }
        return true;
    };

    const clearValues = () => {
        setSubmitClicked(false);
        setRefreshing(false);
        // values
        setMaritalStatus(null);
        setNumOfChildren(0);
        setAddress("");
        setTown("");
        setCountry("");
        setPostcode("");
        setPersonalMobileStored("");
        setPersonalMobileDefaultCode(undefined);
        setPersonalMobileFormatted("");
        setPersonalEmail("");
        // validation error values
        setMaritalError("");
        setChildrenError("");
        setAddressError("");
        setTownError("");
        setCountryError("");
        setPostcodeError("");
        setMobileError("");
        setEmailError("");
    };

    const onAccountSave = async (e) => {
        e.preventDefault();

        setSubmitClicked(true);

        if (!validateFields()) {
            showMessage({
                message: t('common:errAllFields'),
                type: "danger",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
        } else {
            // TODO
            // setIsLoading(true);

            const userData = {
                username: username,
                mStatus: maritalStatusRef.current,
                numOfChildren: numOfChildrenRef.current,
                address: addressRef.current,
                country: countryRef.current,
                postcode: postCodeRef.current,
                personalMobile: mobileInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? mobileInputRef.current.getNumberAfterPossiblyEliminatingZero().formattedNumber : "",
                personalMobileCode: mobileInputRef.current.getNumberAfterPossiblyEliminatingZero().number != "" ? "+" + mobileInputRef.current.getCallingCode() : "",
                personalEmail: personalEmailRef.current,
                town: townRef.current,
            }

            await accountEdit(userData);
            setSubmitClicked(false);
        };
    };

    //#region Use Effect
    useEffect(() => {
        var tempCountriesWithFlagsList = [];

        // declare the data fetching function
        const getCountriesList = async () => {
            // get countries with flags list
            tempCountriesWithFlagsList = await CountriesWithFlagsList(i18n.language, colors, username, user, clientApi);
        };

        // call the function
        getCountriesList()
            .then(() => {
                tempCountriesWithFlagsList.unshift({
                    label: t('common:selectItem'), value: '', labelStyle: styles.emptyItemSelected
                });
                setCountriesWithFlagsList(tempCountriesWithFlagsList);
                // TODO: make loading work
                // setLoading(false);
            })
            // make sure to catch any error
            .catch(console.error);
        // TODO: make loading work
        // setLoading(false);
    }, [i18n.language]);

    /* needed to avoid memory leaks/warnings
       when navigating through different pages */
    useEffect(() => {
        return () => {
            clearValues();
        };
    }, []);

    useEffect(() => {
        submitClickedRef.current = submitClicked;
    }, [submitClicked]);

    useEffect(() => {
        setMaritalStatus(account?.mStatus);
        setNumOfChildren(account?.numOfChildren);
        setAddress(account?.address);
        setTown(account?.town);
        setPostcode(account?.postcode);
        setCountry(account?.country);

        var parsedPersonalMobile = null;
        // try to parse whole mobile phone number (including country code)
        try {
            parsedPersonalMobile = phoneUtil.parse(account?.personalMobile, '')
        } catch (e) {
            // console.log(e);
        };
        // if no stored country code, extract number using library
        // else, extract number using stored country code
        try {
            setPersonalMobileStored(!account?.personalMobileCode && parsedPersonalMobile != null ?
                parsedPersonalMobile.getNationalNumber() :
                account?.personalMobile.replace(account?.personalMobileCode, '')
            );
        } catch (e) {
            console.log(e);
            setPersonalMobileStored(account?.personalMobile);
        };
        // set default country code based on parsed number
        try {
            const defaultCode = phoneUtil.getRegionCodeForNumber(parsedPersonalMobile);
            setPersonalMobileDefaultCode(!defaultCode ? "CY" : defaultCode);
        } catch (e) {
            console.log(e);
            setPersonalMobileDefaultCode("CY");
        };

        setPersonalEmail(account?.personalEmail);
    }, []);

    // Used for Refresh
    const onAccountGet = async () => {
        await accountGet();
    };

    useEffect(() => {
        maritalStatusRef.current = maritalStatus;
        // * Validation for Required (not needed currently)
        // if (submitClickedRef.current) {
        //     validateMarital();
        // };
    }, [maritalStatus]);

    useEffect(() => {
        numOfChildrenRef.current = numOfChildren;
        // * Validation for Required (not needed currently)
        // if (submitClickedRef.current) {
        //     validateChildren();
        // };
    }, [numOfChildren]);

    useEffect(() => {
        addressRef.current = address;
        // * Validation for Required (not needed currently)
        // if (submitClickedRef.current) {
        //     validateAddress();
        // };
    }, [address]);

    useEffect(() => {
        townRef.current = town;
        if (submitClickedRef.current) {
            validateTown();
        };
    }, [town]);

    useEffect(() => {
        countryRef.current = country;
        // * Validation for Required (not needed currently)
        // if (submitClickedRef.current) {
        //     validateCountry();
        // };
    }, [country]);

    useEffect(() => {
        postCodeRef.current = postcode;
        // * Validation for Required (not needed currently)
        // if (submitClickedRef.current) {
        //     validatePostcode();
        // };
    }, [postcode]);

    useEffect(() => {
        personalMobileStoredRef.current = personalMobileStored;
    }, [personalMobileStored]);

    useEffect(() => {
        if (submitClickedRef.current) {
            validateMobile();
        };
    }, [personalMobileFormatted]);

    useEffect(() => {
        personalEmailRef.current = personalEmail;
        if (submitClickedRef.current) {
            validateEmail();
        };
    }, [personalEmail]);

    //#endregion

    // Pull Down to Refresh callback
    const onRefresh = useCallback(() => {
        setRefreshing(true);
        // Call Async Function
        onAccountGet()
            // make sure to catch any error
            .catch(console.error);
        setRefreshing(false);
    }, []);

    return (
        <KeyboardAwareContainer 
            style={{ flex: 1 }}
            contentContainerStyle={{
                flexGrow: 1,
                paddingBottom: Math.max(insets.bottom + 24, 40),
            }}
            enableOnAndroid
            enableAutomaticScroll
            keyboardShouldPersistTaps="handled"
            extraScrollHeight={Platform.OS !== 'web' ? 220 : 200}
            showsVerticalScrollIndicator={false}
            refreshControl={
                <RefreshControl
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                />
            }
        >
            <View style={styles.mainView}>
                <SafeAreaView style={styles.margin}>
                    <CustomLabel
                        value={t('common:personalEmail')}
                        type='MYPROFILE'
                    />

                    <CustomInput
                        value={personalEmail}
                        setValue={setPersonalEmail}
                        editable={user.editPersonalData}
                        type='MYPROFILE'
                        placeholder={`${t('common:personalEmail')}...`}
                    />

                    <CustomText style={styles.error}>{emailError}</CustomText>
                </SafeAreaView>
                <SafeAreaView style={styles.margin}>
                    <CustomLabel
                        value={t('common:personalMobile')}
                        type='MYPROFILE'
                    />
                    {personalMobileDefaultCode !== undefined &&
                        <CustomPhoneNumber
                            ref={mobileInputRef}
                            disabled={!user.editPersonalData}
                            defaultValue={"" + personalMobileStored}
                            defaultCode={personalMobileDefaultCode}
                            onChangeText={setPersonalMobileStored}
                            onChangeFormattedText={(number) => {
                                setPersonalMobileFormatted(number);
                            }}
                            type='MYPROFILE'
                        />
                    }
                    <CustomText style={styles.error}>{mobileError}</CustomText>
                </SafeAreaView>
                <SafeAreaView style={styles.margin}>
                    <CustomLabel
                        value={t('common:address')}
                        type='MYPROFILE'
                    />
                    <CustomInput
                        value={address}
                        editable={user.editPersonalData}
                        setValue={setAddress}
                        type='MYPROFILE'
                        placeholder={`${t('common:address')}...`}
                    />
                    <CustomText style={styles.error}>{addressError}</CustomText>
                </SafeAreaView>
                <View style={Platform.OS === 'web' ? styles.row : styles.margin}>
                    <View style={styles.inputContainer}>
                        <CustomLabel
                            value={t('common:town')}
                            type='MYPROFILE'
                        />
                        <CustomInput
                            value={town}
                            setValue={setTown}
                            editable={user.editPersonalData}
                            type='MYPROFILE'
                            placeholder={`${t('common:town')}...`}
                        />
                        <CustomText style={styles.error}>{townError}</CustomText>
                    </View>
                    <View style={styles.inputContainer}>
                        <CustomLabel
                            value={t('common:postcode')}
                            type='MYPROFILE'
                        />
                        <CustomInput
                            value={postcode}
                            setValue={setPostcode}
                            editable={user.editPersonalData}
                            type='MYPROFILE'
                            placeholder={`${t('common:postcodePlaceholder')}...`}
                        />
                        <CustomText style={styles.error}>{postcodeError}</CustomText>
                    </View>
                </View>
                <View style={[styles.margin, { zIndex: 1 }]}>
                    <CustomLabel
                        value={t('common:country')}
                        type='MYPROFILE'
                    />
                    <CustomDropDownWithIcons
                        defValue={country}
                        disabled={!user.editPersonalData}
                        options={countriesWithFlagsList}
                        value={country}
                        setValue={setCountry}
                        type='MYPROFILE'
                    />
                    <CustomText style={styles.error}>{countryError}</CustomText>
                </View>
                <View style={Platform.OS === 'web' ? styles.row : styles.margin}>
                    <View style={styles.inputContainer}>
                        <CustomLabel
                            value={t('common:marital')}
                            type='MYPROFILE'
                        />
                        <CustomDropDownWithIcons
                            defValue={maritalStatus}
                            disabled={!user.editPersonalData}
                            options={mStatus}
                            value={maritalStatus}
                            setValue={setMaritalStatus}
                            type='MYPROFILE'
                        />
                        <CustomText style={styles.error}>{maritalError}</CustomText>
                    </View>
                    <View style={styles.inputContainer}>
                        <CustomLabel
                            value={t('common:children')}
                            type='MYPROFILE'
                        />
                        {/* Bugged with RN 0.75 switching to TextBox */}
                        {/* <CustomNumericInput
                            value={numOfChildren}
                            setValue={setNumOfChildren}
                            editable={user.editPersonalData}
                            min={0}
                            max={15}
                            type='SM_MYPROFILE'
                        /> */}
                        <CustomInput
                            value={numOfChildren}
                            setValue={setNumOfChildren}
                            editable={user.editPersonalData}
                            type='MYPROFILE'
                            keyboardType="numeric"
                            placeholder={`${t('common:children')}...`}
                        />
                        <CustomText style={styles.error}>{childrenError}</CustomText>
                    </View>
                </View>
                {/* Save Button */}
                <CustomButton
                    text={t('common:save')}
                    onPress={onAccountSave}
                    disabled={!user.editPersonalData || submitClicked}
                    isGradient={true}
                    type={(!user.editPersonalData || submitClicked) ? 'SAVE_WEB_DISABLED' : 'BUTTON_SAVE' }
                />
            </View>
        </KeyboardAwareContainer>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    mainView: {
        flex: 1,
        justifyContent: 'flex-start',
        marginHorizontal: 15,
    },
    inputContainer: {
        flex: 1,
        justifyContent: 'center',
        paddingHorizontal: Platform.OS === 'web' ? 10 : 0, 
        width: '100%',
    },
    margin: {
        marginHorizontal: 10,
        marginVertical: Platform.OS === 'web' ? 5 : 0
    },
    scroll: {
        flex: 1,
        width: (Platform.OS === 'web' && width > 992) ? width / 2 : '100%',
    },
    input: {
        backgroundColor: colors.background_dropdown,
        color: colors.text_input,
        height: 20
    },
    button: {
        color: colors.buttons,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },
    emptyItemSelected: {
        color: '#a1a1a1',
    },
    row: {
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'space-between',
        width: (Platform.OS === 'web' && width > 992) ? null : width,
        paddingRight: (Platform.OS === 'web' && width > 992) ? 0 : '1%',
    },
});
export default MyAccountPersonalInformationScreen;